(() => {
  'use strict';
  function mountRooms(container) {
    container.querySelectorAll('[data-room-inspiration]').forEach((section) => {
      if (section.dataset.roomsReady) return;
      const root = section.closest('[data-homewoods]');
      const livingScene = root?.querySelector('[data-gallery-select][data-room-scene="living"]');
      const bedroomScene = root?.querySelector('[data-gallery-select][data-room-scene="bedroom"]');
      const image = section.querySelector('.hw-room-photo > img');
      const caption = section.querySelector('.hw-room-photo__caption');
      const story = section.querySelector('[data-room-story]');
      const switcher = section.querySelector('.hw-room-switcher');
      if (!livingScene || !bedroomScene || !image || !caption || !story || !switcher) return;
      const rooms = {
        living: {
          source: livingScene.dataset.src,
          alt: livingScene.dataset.alt,
          label: 'Living room · AI-styled Light Oak',
          story: 'Give the wall behind your sofa a little rhythm. Pair warm timber tones with relaxed upholstery and natural light.'
        },
        bedroom: {
          source: bedroomScene.dataset.src,
          alt: bedroomScene.dataset.alt,
          label: 'Bedroom · AI-styled Light Oak',
          story: 'Frame the bed with vertical texture and keep the rest soft, simple and calm.'
        }
      };
      if (!rooms.living.source || !rooms.bedroom.source) return;
      switcher.addEventListener('click', (event) => {
        const button = event.target.closest('[data-room-choice]');
        if (!button || !switcher.contains(button)) return;
        const room = rooms[button.dataset.roomChoice];
        if (!room) return;
        image.src = room.source;
        image.alt = room.alt || room.label;
        caption.textContent = room.label;
        story.textContent = room.story;
        switcher.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
      image.src = rooms.bedroom.source;
      image.alt = rooms.bedroom.alt || rooms.bedroom.label;
      caption.textContent = rooms.bedroom.label;
      switcher.hidden = false;
      section.dataset.roomsReady = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountRooms(document), { once: true });
  else mountRooms(document);
  document.addEventListener('shopify:section:load', (event) => mountRooms(event.target));
})();
